var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoQuotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 22,
    viewBox: "0 0 50 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.845703 10.9766C0.845703 11.2207 0.943359 11.4648 1.12891 11.6309L8.87305 19.1895C9.03906 19.3555 9.25391 19.4531 9.49805 19.4531C10.0059 19.4531 10.3965 19.0723 10.3965 18.5645C10.3965 18.3203 10.2988 18.0957 10.1426 17.9297L3.0332 10.9766L10.1426 4.01367C10.2988 3.85742 10.3965 3.63281 10.3965 3.37891C10.3965 2.87109 10.0059 2.49023 9.49805 2.49023C9.25391 2.49023 9.03906 2.58789 8.86328 2.75391L1.12891 10.3125C0.943359 10.498 0.845703 10.7227 0.845703 10.9766Z",
    fill: "#68899A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1543 10.9766C49.1543 11.2207 49.0566 11.4648 48.8711 11.6309L41.127 19.1895C40.9609 19.3555 40.7461 19.4531 40.502 19.4531C39.9941 19.4531 39.6035 19.0723 39.6035 18.5645C39.6035 18.3203 39.7012 18.0957 39.8574 17.9297L46.9668 10.9766L39.8574 4.01367C39.7012 3.85742 39.6035 3.63281 39.6035 3.37891C39.6035 2.87109 39.9941 2.49023 40.502 2.49023C40.7461 2.49023 40.9609 2.58789 41.1367 2.75391L48.8711 10.3125C49.0566 10.498 49.1543 10.7227 49.1543 10.9766Z",
    fill: "#68899A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoQuotes);
export default __webpack_public_path__ + "static/media/ico-quotes.caa577aaa911b77c97a2beec74454fc7.svg";
export { ForwardRef as ReactComponent };